<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <IDSKDetails open :title="t('zoppm.step0.prilohy')" class="mb-9">
    <IDSKRow>
      <IDSKCol variant-desktop="two-thirds">
        <IDSKParagraph>{{ t('zoppm.step0.prilohySubTitle') }} </IDSKParagraph>
        <IDSKParagraph>{{ t('zoppm.step0.prilohySubTitle1') }} </IDSKParagraph>
        <IDSKParagraph>{{ t('zoppm.step0.prilohySubTitle2') }} </IDSKParagraph>
      </IDSKCol>
    </IDSKRow>
    <PrilohyTable />
  </IDSKDetails>
</template>

<style lang="scss"></style>
